<template>
  <div class="relative" :class="withLabel ? 'mt-2' : ''">
    <div
      v-if="withLabel"
      class="absolute -top-2 left-2 z-40 -mt-px inline-block h-3 bg-white px-1 text-xs font-medium text-gray-900 capitalize-first"
    >
      {{ $t(translation + nameTranslate) }}
    </div>
    <ul
      class="grid w-full items-center gap-2 rounded-lg bg-white text-sm font-medium text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
      :class="[
        !$can('manage_settings') ? 'cursor-not-allowed' : '',
        `grid-cols-${gridCols}`
      ]"
    >
      <li
        v-for="(option, index) in options"
        :key="index"
        class="flex h-full w-full items-center dark:border-gray-600 sm:rounded-md sm:border sm:border-slate-200"
      >
        <div class="flex items-center pl-3">
          <input
            :id="option.id"
            type="checkbox"
            :value="option.id"
            :checked="isSelected(option.id)"
            class="h-4 w-4 rounded bg-gray-100 text-blue-600 focus:ring-2 focus:ring-blue-500 dark:border-gray-500 dark:bg-gray-600 dark:ring-offset-gray-700 dark:focus:ring-blue-600 dark:focus:ring-offset-gray-700"
            :disabled="!$can('manage_settings')"
            @change="toggleSelection(option)"
          />
          <label
            :for="option.id"
            class="ml-2 w-full py-3 text-sm font-medium text-gray-900 capitalize-first dark:text-gray-300"
          >
            {{ option.name }}
          </label>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'BaseCheckBoxGroup',
  props: {
    optionsSelected: {
      type: Array,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    gridCols: {
      type: [Number, String],
      required: false,
      default: 4
    },
    withLabel: {
      type: Boolean,
      required: false,
      default: false
    },
    translation: {
      type: String,
      required: false,
      default: 'enums.settings.settingsKeys.'
    },
    translationName: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['update:optionsSelected'],
  data() {
    return {
      localOptionsSelected: []
    }
  },
  computed: {
    nameTranslate() {
      return this.translationName ?? this.name
    }
  },
  watch: {
    optionsSelected: {
      handler(newValue) {
        this.localOptionsSelected = [...newValue]
      },
      deep: true
    }
  },
  mounted() {
    this.localOptionsSelected = this.optionsSelected
  },
  methods: {
    isSelected(optionId) {
      if (this?.localOptionsSelected?.length) {
        return this?.localOptionsSelected?.includes(optionId)
      }
    },
    toggleSelection(option) {
      let array = []
      if (this?.localOptionsSelected) {
        array = this?.localOptionsSelected
      }
      const index = array.indexOf(option.id)
      if (index > -1) {
        array.splice(index, 1)
      } else {
        array.push(option.id)
      }
      this.$emit('update:optionsSelected', array)
    }
  }
}
</script>
